import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";

export class AutorizacaoRotaModel {
  constructor(
    public rota: string = "",
    public permissoes: Array<EnumTipoPessoas | undefined> = [],
  ) { }
}
